/**
 * 簡易予測プレビュー mutation hook (§7 簡易予測の一括取込プレビュー化, ADR
 * demand-forecast-import-preview-only)。
 *
 * PreviewSimpleForecast RPC を呼んで、指定した簡易予測手法 (単純前日コピー /
 * 同区分前週コピー / 加重移動平均 / 同区分加重平均) の算出結果を取得する。
 * draft への書込みは行われない (persist しない) — caller (index.tsx /
 * useSimpleForecastImportFlow) が応答を未保存バッファ (editRows の現在値) へ
 * 適用し、永続化は明示保存 (SaveDemandForecastDraft) が別途担う。
 * 楽観ロックは不要 (書込みが無いため expected_updated_at を持たない)。
 */
import type { MessageInitShape, MessageShape } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useMutation } from '@connectrpc/connect-query'
import { previewSimpleForecast } from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import {
  PreviewSimpleForecastRequestSchema,
  PreviewSimpleForecastResponseSchema,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'
import type { UseMutationResult } from '@tanstack/react-query'

/**
 * 簡易予測の算出結果をプレビュー取得する mutation hook (draft へ書込まない)。
 * request は caller が `create(PreviewSimpleForecastRequestSchema, {...})` で組み立てて渡す。
 */
export function usePreviewSimpleForecast(): UseMutationResult<
  MessageShape<typeof PreviewSimpleForecastResponseSchema>,
  ConnectError,
  MessageInitShape<typeof PreviewSimpleForecastRequestSchema>
> {
  return useMutation(previewSimpleForecast)
}
